import { render, staticRenderFns } from "./InfoautoCustomerAddressesPhones.vue?vue&type=template&id=562440a6&scoped=true"
import script from "./InfoautoCustomerAddressesPhones.vue?vue&type=script&lang=js"
export * from "./InfoautoCustomerAddressesPhones.vue?vue&type=script&lang=js"
import style0 from "./InfoautoCustomerAddressesPhones.vue?vue&type=style&index=0&id=562440a6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562440a6",
  null
  
)

export default component.exports